import { TAutocompleteOption } from '~/components/AutocompleteField/types';
import { TGeneralInfoLegalResident } from '~/modules/identification/forms/GeneralInfo/types.ts';
import { ukraineOption } from '~/modules/identification/constants.ts';
import { ClientTypes } from '~/constants/clientTypes.ts';

export const emptyAutocompleteItem: TAutocompleteOption = { label: '', value: '-1' };

export const additionalInfoColumns = [
  {
    title: '№',
    size: 0.5,
  },
  {
    title:
      "Інформація про зв'язки клієнта банку із державою, що здійснює збройну агресію проти України",
    size: 9.5,
  },
  {
    title: 'Варіант відповіді',
    size: 2,
  },
];

export const infoMessagesAdditionQuestionnaire = {
  SOLE_TRADER:
    '*У разі відповіді «Так» обов’язково надаються документи/інформація в обсягах передбачених\n' +
    'постановою Правління Національного банку України від 16 березня 2023 року №26 та внутрішніми\n' +
    'документами Банку, в чинній редакції.',
  LEGAL_RESIDENT:
    '*У разі відповіді «Так» надаються документи/інформація в обсягах передбачених постановою Правління Національного банку\n' +
    'України від 16 березня 2023 року №26, та внутрішніми документами Банку, в чинній редакції.',
};

export const infoTextCountriesFATCA = {
  birthplaceCountryUSA: 'Країна народження - Сполучені Штати Америки',
  permanentAddressUSA: 'Адреса фактичного місця проживання - Сполучені Штати Америки',
  citizenshipCountryUSA: 'Країна громадянства',
  residenceCountryUSA: 'Країна резидентства',
};

export const infoMessagesFATCA = {
  COUNTRY_OF_BIRTH_OR_RESIDENTIAL_ADDRESS: (countries: string[]) =>
    `Виявлено ознаку відношення до FATCA: «${countries.join('; ')}». Якщо Ви не є громадянином чи податковим резидентом США, у розділі «Додаткова інформація» оберіть «Ні»: потрібно буде надати форму W-8BEN та один із документів - DS 4083, І-407 або письмові пояснення. Якщо Ви громадянин / податковий резидент США - оберіть «Так» (форма W-9 і копія TIN).`,
  CITIZEN_USA: (countries: string) =>
    `Зазначено країну «Сполучені Штати Америки» (${countries}). Вас буде визначено як податкового резидента США - у розділі «Додаткова інформація» заповнення блоку FATCA та завантаження форми W-9 стануть обов'язковими.`,
};

export const testDataGeneralInfoSoleTrader = {
  fullName: 'Тарас Григорович Шевченко',
  address: {
    registrationAddress: {
      address: 'Україна, 12345, м.Київ, вул. Хрещатик, 22',
      country: ukraineOption,
      postalCode: '12345',
      region: { value: '26', label: 'м.Київ' },
      district: { value: '', label: '' },
      city: { value: '191919', label: 'м.Київ' },
      street: { value: '25979', label: 'вул. Хрещатик' },
      houseNumber: '22',
      building: null,
      apartment: null,
      codeAddress: 'UA80000000000093317',
    },
    permanentAddress: {
      address: 'Україна, 12345, м.Київ, вул. Хрещатик, 22',
      country: ukraineOption,
      postalCode: '12345',
      region: { value: '26', label: 'м.Київ' },
      district: { value: '', label: '' },
      city: { value: '191919', label: 'м.Київ' },
      street: { value: '25979', label: 'вул. Хрещатик' },
      houseNumber: '22',
      building: null,
      apartment: null,
      codeAddress: 'UA80000000000093317',
    },
    coincidences: true,
    birthplaceCountry: { value: '840', label: 'Сполучені Штати Америки' },
    citizenshipCountry: { value: '804', label: 'Україна' },
    residenceCountry: { value: '804', label: 'Україна' },
  },
  birthDate: '09.03.1998',
  birthPlace: 'м. Київ',
  uniqueDemographicRecordNumber: '1234567890123',
  documents: {
    documentType: { value: '1', label: 'Паспорт громадянина України' },
    registryRecord: null,
    documentSeries: 'АА',
    documentNumber: '123451',
    issueDate: '12.08.1998',
    documentExpiryDate: null,
    issuingAuthority: 'HT',
  },
  financialPhone: '+380671112233',
  contactNumbers: ['+380671112233'],
  emailAddress: ['test@test.ua'],
  license: false,
  licenses: [],
  questionnaire: {
    question1: false,
    question2: false,
    question3: false,
    question4: false,
    question5: false,
    question6: false,
    question7: false,
    question8: false,
    question9: false,
  },
  isUSTaxResident: false,
  isOtherTaxResident: false,
  cerOfLossOfUSCitizenship: null,
  explainRegardingLackOfUSCitizenship: null,
  taxIdentNumber: null,
  taxstatusinternation: null,
  fullNameInEng: null,
  businessabroad: null,
  'CRS-I': null,
  type: ClientTypes.SOLE_TRADER,
  foreignLegalEntity: null,
};

export const testDataGeneralInfoLegalResident: TGeneralInfoLegalResident = {
  fullNameUkr: 'ПРИВАТНЕ АКЦІОНЕРНЕ ТОВАРИСТВО "ВФ УКРАЇНА"',
  fullNameEng: 'PRJSC "VF UKRAINE"',
  shortNameUkr: 'ПРАТ "ВФ УКРАЇНА"',
  employeeCount: '22',
  address: {
    registrationAddress: {
      address: 'Україна, 12345, м.Київ, вул. Хрещатик, 22',
      country: ukraineOption,
      postalCode: '12345',
      region: { value: '26', label: 'м.Київ' },
      district: { value: '', label: '' },
      city: { value: '191919', label: 'м.Київ' },
      street: { value: '25979', label: 'вул. Хрещатик' },
      houseNumber: '22',
      building: null,
      apartment: null,
      codeAddress: 'UA80000000000093317',
    },
    permanentAddress: {
      address: 'Україна, 12345, м.Київ, вул. Хрещатик, 22',
      country: ukraineOption,
      postalCode: '12345',
      region: { value: '26', label: 'м.Київ' },
      district: { value: '', label: '' },
      city: { value: '191919', label: 'м.Київ' },
      street: { value: '25979', label: 'вул. Хрещатик' },
      houseNumber: '22',
      building: null,
      apartment: null,
      codeAddress: 'UA80000000000093317',
    },
    coincidences: true,
  },
  financialPhone: '+380671112233',
  contactNumbers: ['+380671112233'],
  emailAddress: ['test@test.ua'],
  questionnaire: {
    question1: false,
    question2: false,
    question3: false,
    question4: false,
    question5: false,
    question6: false,
    question7: false,
    question8: false,
    question9: false,
    question10: false,
    question11: false,
    question12: false,
    question13: false,
    question14: false,
  },
  isOtherTaxResident: false,
  isControllingPersonTaxResidentOtherJurisdiction: true,
  isUSTaxResident: true,
  isForeignFinancialUnderFATCA: false,
  isControllingPersonUSTaxResident: false,
  hasForeignShare: false,
  'CRS-E': null,
  type: ClientTypes.LEGAL_RESIDENT,
  foreignLegalEntity: null,
};
